import React from 'react';
import { navigate } from 'gatsby';
import {
  FromDateRange,
  toDateRange
} from '../../containers/CallDetails/CallDetails';
import './CallDetail.css';

const onRowClick = (e, row, selector) => {
  e.stopPropagation();

  if (selector) {
    navigate(
      `/app/dashboard?status=${selector}&fromDate=${FromDateRange()}&toDate=${toDateRange()}&rm=${
        row.id
      }`
    );
  } else {
    console.log(' selector Not found!');
  }
};
const Columns = [
  {
    name: (
      <div className="text-left serial text-right">
        S No.
      </div>
    ),
    selector: 'index',

    sortable: false,
    cell: row => {
      return (
        <div className="w-full mx-auto text-left "
        style={{ maxWidth: '20px' }}>
          <p
            className="text-center whitespace-pre "
            style={{ whiteSpace: 'break-spaces' }}
          >
            {row.serial_number}
          </p>
        </div>
      );
    }
  },
  {
    name: <div className="text-left ">Sales Manager</div>,
    selector: 'firstName',
    sortable: true,
    cell: row => {
      return (
        <div className="w-full mx-auto text-left  lg:pl-6 md:pl-4">
          <p
            className="text-left whitespace-pre"
            style={{ whiteSpace: 'break-spaces' }}
          >
{(row.firstName || row.lastName)?
(row.firstName ?row.firstName+" ":"")
 +
(row.lastName ?row.lastName :"")
:<span>&#8212; </span>
  }
          </p>
        </div>
      );
    }
  },
  {
    name: <div className="text-left ">Location</div>,
    selector: 'city',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className="text-center whitespace-pre"
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.city ? row.city : <span>&#8212; </span>}
        </p>
      </div>
    )
  },
  {
    name: <div className="text-right ">No of Calls Made</div>,
    selector: 'total',
    sortable: true,
    cell: row => (
      <div
        className="w-full lg:ml-10 md:ml-8 xs:ml-6 cursor-pointer "
        onClick={e => onRowClick(e, row, 'All')}
      >
        <p className=" whitespace-pre" style={{ whiteSpace: 'break-spaces' }}>
          {row.total ? row.total : 0}
        </p>
      </div>
    )
  },
  {
    name: <div className="text-green-500 text-right ">Leads</div>,
    selector: 'leads',
    sortable: true,
    cell: row => (
      <div
        className="w-full lg:ml-0 md:ml-8 xs:ml-6 cursor-pointer "
        onClick={e => onRowClick(e, row, 'New Lead')}
      >
        <p
          className="text-center whitespace-pre"
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.leads ? row.leads : 0}
        </p>
      </div>
    )
  },
  {
    name: <div className="text-blue-500 text-right">Follow Up</div>,
    selector: 'followUp',
    sortable: true,
    cell: row => (
      <div
        className="w-full lg:ml-4 md:ml-8 xs:ml-6 cursor-pointer"
        onClick={e => onRowClick(e, row, 'Follow Up')}
      >
        <p
          className="text-center whitespace-pre "
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.followUp ? row.followUp : 0}
        </p>
      </div>
    )
  },
  {
    name: <div className="text-red-100 text-right">Not Interested</div>,
    selector: 'notInterested',
    sortable: true,
    cell: row => (
      <div
        className="w-full lg:ml-13 md:ml-8 xs:ml-6 cursor-pointer"
        onClick={e => onRowClick(e, row, 'Not Interested')}
      >
        <p
          className="text-center whitespace-pre "
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.notInterested ? row.notInterested : 0}
        </p>
      </div>
    )
  },
  {
    name: <div className="text-green-500 text-right">Accepted</div>,
    selector: 'login',
    sortable: true,
    cell: row => (
      <div
        className="w-full lg:ml-4 md:ml-8 xs:ml-6 cursor-pointer"
        onClick={e => onRowClick(e, row, 'Login')}
      >
        <p
          className="text-center whitespace-pre"
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.login ? row.login : 0}
        </p>
      </div>
    )
  }
];
export default Columns;
